export default {
  API_ERROR: "Sorry, iets ging fout. Probeer het opnieuw.",
  FORM_ERROR: "Sorry, maar je moet iets meer schrijven om je feedback met ons te delen."
}